






















































































import { Component, Prop, Vue } from "vue-property-decorator";
import { actions } from "@/observables";
import { convertLocaleKgToPounds, convertLocaleLToGal, convertSecMin } from "@/helpers/convert";

@Component({
  components: {}
})
export default class Load extends Vue {
  @Prop() load!: Load.Load;

  /* Data */
  loading = false;
  isLiquid = true;

  /* Computed */
  get hasTrip() {
    return !!this.load.trips.length;
  }

  get canOpenLoadModal() {
    return this.loading || !this.load.trips.length;
  }

  get getColor() {
    return this.load.autoLoad ? "load-primary-color-text" : "load-stoped-text";
  }

  get getBackgroundRibbonColor() {
    return this.load.dispatch
      ? "ribbon-color-dispatch"
      : this.load.autoLoad
      ? "ribbon-color"
      : "ribbon-color-stoped";
  }

  get getColorAutoLoad() {
    return this.load.autoLoad ? "load-stoped-text" : "load-theme-color ";
  }

  /* Methods */
  getQuantity() {
    let quantity = 0;
    for (const tankDetail of this.load.tankDetailList) {
      if (tankDetail) {
        this.isLiquid = tankDetail.liquid;
        tankDetail.mixProducts.forEach(mix => (quantity += mix.quantity));
      }
    }
    return quantity;
  }

  get duration() {
    const duration = this.checkLastUpdateTender();
    // Faz uma retrieve abaixo de 10 minutos caso não tenha trip e o auto-loading esteja ativado
    if (duration <= 600 && !this.load.trips.length && this.load.autoLoad) {
      this.retrieveTrip(true);
    }
    return this.load.route
      ? `${convertSecMin(duration)} ${this.$tc("load.timer", convertSecMin(duration))}`
      : this.$t("load.timerUndefined");
  }

  // Checa a ultima atualização do tender e decrementa da duração caso esteja em deslocamento
  checkLastUpdateTender() {
    let duration = 0;
    if (this.load.estado === "DESLOCAMENTO" && this.load.route) {
      duration =
        this.load.route.duration > this.load.secondsLastUpdate
          ? this.load.route.duration - this.load.secondsLastUpdate
          : 0;
    } else if (this.load.route) {
      duration = this.load.route.duration;
    }
    return duration;
  }

  getTickets() {
    const tickets = { full: "", display: "" };
    tickets.full = this.load.trips
      .map(
        (trip: { sprayerOsTicket: string; vrt: boolean }) =>
          `#${trip.sprayerOsTicket}${trip.vrt ? " (VRT)" : ""}`
      )
      .join(", ");
    tickets.display = tickets.full;
    if (tickets.full.length > 50) {
      tickets.display = tickets.full.substring(0, 50) + "...";
    }
    return tickets;
  }

  getProducts() {
    const products = { full: "", display: "" };
    const tankDetailList = this.load.tankDetailList;
    this.load.tankDetailList.forEach((datail, key) => {
      products.full += `${datail.mixProducts.map(mix => mix.product.descProduto).join(", ")}${
        tankDetailList.length === key + 1 ? "." : ", "
      }`;
      products.display = products.full;
    });
    if (products.full.length > 60) {
      products.display = products.full.substring(0, 60) + "...";
    }
    return products;
  }

  convertLocaleLToGal(): number {
    return convertLocaleLToGal(this.$i18n.locale, this.getQuantity());
  }

  convertLocaleKgToPounds(): number {
    return convertLocaleKgToPounds(this.$i18n.locale, this.getQuantity());
  }

  openLoad() {
    if (this.load.trips.length) {
      this.$emit("openLoad", this.load.tenderId);
    }
  }

  async retrieveTrip(isBackground = false) {
    this.loading = true;
    try {
      await actions.generateLoads(this.load.tenderId);
      if (!isBackground) {
        actions.fetchLoads();
      }
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  }

  async changeLoad() {
    this.loading = true;
    try {
      await actions.changeAutoLoad(this.load.tenderId, !this.load.autoLoad);
      actions.fetchLoads();
    } catch (e) {
      console.error(e);
    } finally {
      this.loading = false;
    }
  }
}
